import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonLabel,
  IonSpinner,
} from '@ionic/react';
import React, { ReactElement, memo } from 'react';
import { Machine } from '../../../api/graphql/generated';
import { MonitorIOBindingResult } from '../../../api/hooks/binding/binding.types';
import { useMachineIO } from '../../../api/hooks/machine-io.hooks';
import i18n from '../../../i18n';
import { useBeaconRouter } from '../../../route/route.hooks';
import { useMachineIOFavorites } from '../../../store/favorites/favorites.hooks';
import {
  getIOFavoriteKey,
  getIOFromFavoriteKey,
  getIOStandardName,
} from '../io.utils';
import { IOIcon } from '../machine-io';

interface IOCardProps {
  machine?: Machine;
}

const IOCard = memo((props: IOCardProps): ReactElement => {
  const { machine } = props;

  const io = useMachineIO({
    id: machine?.id,
  });
  const favs = useMachineIOFavorites(machine);

  const { builder } = useBeaconRouter();

  return (
    <IonCard
      className="machine-card-container io-container"
      routerLink={
        machine
          ? builder.getMachineIORoute(machine.teamId, machine.id)
          : undefined
      }
    >
      <IonCardHeader>
        <IonCardTitle>{i18n.t('common:machine_io_favorites')}</IonCardTitle>
      </IonCardHeader>

      {favs?.length ? (
        <div className="machine-card-info-grid">
          {favs?.map((fav, index) => {
            const item: MonitorIOBindingResult | undefined = io.find(
              (io: MonitorIOBindingResult) => getIOFavoriteKey(io) === fav
            );
            const favItem = { ...getIOFromFavoriteKey(fav), ...item };
            const stdIOName = getIOStandardName(favItem);
            return (
              <React.Fragment key={index}>
                <div className="machine-card-info-grid-label">
                  <IonLabel>
                    <h2>{favItem.label ?? stdIOName}</h2>
                    <p>{stdIOName}</p>
                  </IonLabel>
                </div>
                <div className="machine-card-info-grid-value">
                  {item ? <IOIcon io={item} /> : <IonSpinner name="dots" />}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      ) : (
        <GettingStartedWithIO />
      )}
    </IonCard>
  );
});

IOCard.displayName = 'IOCard';

const GettingStartedWithIO = (): ReactElement => {
  return (
    <p className="card-description">{i18n.t('common:get_started_with_io')}</p>
  );
};

export { IOCard };
